import { showSpinner, hideSpinner } from "store/slices/spinner";
import { api } from "store/slices/api";
import { toast } from "react-toastify";
import {
  searchMqProjects,
  searchMqProjectsForEdit,
  searchMqProjectsSucess,
  searchMqProjectForEditSuccess,
  getRoomsInfoByMqProjectSuccess,
  setImageData,
  updateSelectProject,
  updateSelectAllProjects,
  searchSites,
  searchSitesSuccess,
  setSiteData,
  removeLayer,
  getLaborCodeList,
  getAllSiteNames as getAllSitenamesAction,
  setRerunBulkUpdateData,
  editProjectData,
  loadCutSheetsData,
  addProduct as addProductAction,
  deleteRollcut as deleteRollcutAction,
  submitCreateSite,
} from "store/slices/siteRepo";
import axios from "services/config";
import {
  getRoomsInfoByMultipleProject,
  createNewSite,
  searchSite,
  getSite,
  getFloorImages,
  deleteLayer,
  addLaborCodeToProduct,
  deleteLaborCodeService,
  getlaborCodeList,
  updateProductService,
  deleteProductService,
  addManualProductService,
  createQuoteFromSiteService,
  updateRoomService,
  getAllSiteNamesService,
  getChangeLogService,
  deleteMeasurementService,
  bulkUpdateSiteService,
  getRerunBulkUpdateService,
  getCutSheetsService,
} from "services/siteRepo.service";
import { API } from "services/api";

export const searchMqProjectsSubmit = (data) => async (dispatch) => {
  dispatch(searchMqProjects());
  dispatch(showSpinner());
  const { searchMqProjectsFields, userId } = data;

  try {
    const res = await axios.get(`${API.siteRepo.root}${API.siteRepo.searchMqProjects}/${userId}`);
    dispatch(searchMqProjectsSucess({ res: res.data, searchFields: searchMqProjectsFields }));
  } catch (err) {
    toast.error(err.status === 400 ? " There are no projects for the specified user" : err.message);
  } finally {
    dispatch(hideSpinner());
  }
};

export const searchMqProjectNameSubmit = (data) => async (dispatch) => {
  dispatch(searchMqProjects());
  dispatch(showSpinner());
  const { searchMqProjectsFields, userId, name } = data;
  try {
    const res = await axios.get(`${API.siteRepo.root}${API.siteRepo.searchMqProjects}/${userId}/${name}`);
    dispatch(searchMqProjectsSucess({ res: res.data, searchFields: searchMqProjectsFields }));
  } catch (err) {
    toast.error(err.status === 400 ? " There are no projects for the specified user" : err.message);
  } finally {
    dispatch(hideSpinner());
  }
};

export const searchMqProjectNameEditSubmit = (data) => async (dispatch) => {
  dispatch(searchMqProjectsForEdit());
  dispatch(showSpinner());
  const { searchMqProjectsFields, userId, name } = data;
  try {
    const res = await axios.get(`${API.siteRepo.root}${API.siteRepo.searchMqProjects}/${userId}/${name}`);
    dispatch(searchMqProjectForEditSuccess({ res: res.data, searchFields: searchMqProjectsFields }));
  } catch (err) {
    toast.error(err.status === 400 ? " There are no projects for the specified user" : err.message);
  } finally {
    dispatch(hideSpinner());
  }
};

export const searchMqProjectsSubmitForEdit = (data) => async (dispatch) => {
  dispatch(searchMqProjectsForEdit());
  dispatch(showSpinner());
  const { searchMqProjectsFields, userId } = data;

  try {
    const res = await axios.get(`${API.siteRepo.root}${API.siteRepo.searchMqProjects}/${userId}`);
    dispatch(searchMqProjectForEditSuccess({ res: res.data, searchFields: searchMqProjectsFields }));
  } catch (err) {
    toast.error("Enter a valid email");
  } finally {
    dispatch(hideSpinner());
  }
};

export const getRoomsByMqProject = (mprojectId, index, isClosed, isEdit) => async (dispatch) => {
  dispatch(showSpinner());

  try {
    const res = await axios.get(`${API.siteRepo.root}${API.siteRepo.getLayerByProject.replace("{0}", mprojectId)}`);
    dispatch(getRoomsInfoByMqProjectSuccess({ res: res.data, index, isEdit }));

    if (isClosed) {
      dispatch(updateSelectProject({ selectProjectIndex: index, isEdit }));
    }
    return res.data;
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  } finally {
    dispatch(hideSpinner());
  }
};

export const getLayerImage = (projects, isEdit) => async (dispatch) => {
  const res = await getFloorImages(projects);
  dispatch(setImageData({ res, isEdit }));
};

export const selectAllProjects = (projects, isChecked, isEdit) => async (dispatch) => {
  dispatch(showSpinner());
  if (isChecked) {
    dispatch(hideSpinner());
    dispatch(updateSelectAllProjects({ projectsArray: [], isChecked, isEdit }));
  } else {
    return getRoomsInfoByMultipleProject(projects)
      .then((projectsResp) => {
        dispatch(hideSpinner());
        dispatch(updateSelectAllProjects({ projectsArray: projectsResp, isChecked, isEdit }));
        return projectsResp;
      })
      .catch((err) => {
        console.error(err);
        dispatch(hideSpinner());
      });
  }
};

export const submitCreateNewSite = (siteData, viewSiteObj) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    const res = await createNewSite(siteData);
    dispatch(submitCreateSite({ createSiteResponse: res, viewSiteObj }));
    return res;
  } catch (err) {
    const errMsg = err.response?.data?.error?.match(/Data too long for column '([^']+)'/);
    toast.error(
      errMsg
        ? `Cannot create a site as the data is too long for the column ${errMsg[1].replace(/_/g, " ")}`
        : "Failed to create site",
    );
    return Promise.reject(err);
  } finally {
    dispatch(hideSpinner());
  }
};

export const searchSitesAction = (data) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    dispatch(searchSites());
    const res = await searchSite(data);
    dispatch(searchSitesSuccess(res));
  } catch (err) {
    toast.error("Something went wrong");
  } finally {
    dispatch(hideSpinner());
  }
};

export const getSiteDetails = (siteId) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    const res = await getSite(siteId);
    res.projectDetailsList
      ? res.projectDetailsList?.map((project) => {
          project.isSelected = true;
          project.layerInfoList?.map((layer) => {
            layer.isSelected = true;
            layer.pictureData = layer.pictureData ? "data:image/jpeg;base64," + layer.pictureData : null;
          });
        })
      : (res.projectDetailsList = []);
    dispatch(setSiteData(res));
    return res;
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  } finally {
    dispatch(hideSpinner());
  }
};

export const deleteFloor = (projectId, body, isView) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    if (await deleteLayer(body)) {
      dispatch(removeLayer({ projectId, layerId: body.layerId, isView }));
    }
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  } finally {
    dispatch(hideSpinner());
  }
};

export const getlaborCodeOptions = () => async (dispatch) => {
  try {
    const res = await getlaborCodeList();
    dispatch(getLaborCodeList(res));
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  }
};

export const addLaborCodeForProduct = (data, siteId) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    await addLaborCodeToProduct(data);
    const res = await getSite(siteId);
    res.projectDetailsList
      ? res.projectDetailsList?.map((project) => {
          project.isSelected = true;
          project.layerInfoList?.map((layer) => {
            layer.isSelected = true;
            layer.pictureData = layer.pictureData ? "data:image/jpeg;base64," + layer.pictureData : null;
          });
        })
      : (res.projectDetailsList = []);

    dispatch(setSiteData(res));
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  } finally {
    dispatch(hideSpinner());
  }
};

export const deleteLaborCodeForProduct = (data, siteId) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    await deleteLaborCodeService(data);
    const res = await getSite(siteId);
    res.projectDetailsList
      ? res.projectDetailsList?.map((project) => {
          project.isSelected = true;
          project.layerInfoList?.map((layer) => {
            layer.isSelected = true;
            layer.pictureData = layer.pictureData ? "data:image/jpeg;base64," + layer.pictureData : null;
          });
        })
      : (res.projectDetailsList = []);

    dispatch(setSiteData(res));
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  } finally {
    dispatch(hideSpinner());
  }
};

export const updateProduct = (data, siteId) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    await updateProductService(data);
    const res = await getSite(siteId);
    res.projectDetailsList
      ? res.projectDetailsList?.map((project) => {
          project.isSelected = true;
          project.layerInfoList?.map((layer) => {
            layer.isSelected = true;
            layer.pictureData = layer.pictureData ? "data:image/jpeg;base64," + layer.pictureData : null;
          });
        })
      : (res.projectDetailsList = []);
    dispatch(setSiteData(res));
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  } finally {
    dispatch(hideSpinner());
  }
};

export const removeProduct = (data, siteId) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    await deleteProductService(data);
    const res = await getSite(siteId);
    res.projectDetailsList
      ? res.projectDetailsList?.map((project) => {
          project.isSelected = true;
          project.layerInfoList?.map((layer) => {
            layer.isSelected = true;
            layer.pictureData = layer.pictureData ? "data:image/jpeg;base64," + layer.pictureData : null;
          });
        })
      : (res.projectDetailsList = []);
    dispatch(setSiteData(res));
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  } finally {
    dispatch(hideSpinner());
  }
};

export const addProduct = (data, projectId) => async (dispatch) => {
  // TODO: this endpoint sucks we need to replace it
  const { rooms, layerId } = await addManualProductService(data);
  const product = rooms?.[0]?.products?.[0];
  dispatch(addProductAction({ projectId, layerId, product }));
};

export const createQuoteFromSite = (data) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    const res = await createQuoteFromSiteService(data);
    dispatch(api.util.invalidateTags(["Quote"]));
    return res;
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  } finally {
    dispatch(hideSpinner());
  }
};

export const updateRoom = (data, siteId) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    await updateRoomService(data);
    const res = await getSite(siteId);
    res.projectDetailsList
      ? res.projectDetailsList?.map((project) => {
          project.isSelected = true;
          project.layerInfoList?.map((layer) => {
            layer.isSelected = true;
            layer.pictureData = layer.pictureData ? "data:image/jpeg;base64," + layer.pictureData : null;
          });
        })
      : (res.projectDetailsList = []);

    dispatch(setSiteData(res));
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  } finally {
    dispatch(hideSpinner());
  }
};

export const getAllSiteNames = () => async (dispatch) => {
  dispatch(getAllSitenamesAction(await getAllSiteNamesService()));
};

export const searchSitesForBulkUpdate = (data) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    const response = await axios.post(`/fc-site-repo/search/bulk/product`, data);
    return response.data.map((site) => ({ ...site, isSelected: false }));
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  } finally {
    dispatch(hideSpinner());
  }
};

export const bulkUpdateSiteProducts = (data, siteId) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    await bulkUpdateSiteService(data);
    const res = await getSite(siteId);
    res.projectDetailsList
      ? res.projectDetailsList?.map((project) => {
          project.isSelected = true;
          project.layerInfoList?.map((layer) => {
            layer.isSelected = true;
            layer.pictureData = layer.pictureData ? "data:image/jpeg;base64," + layer.pictureData : null;
          });
        })
      : (res.projectDetailsList = []);

    dispatch(setSiteData(res));
    return res;
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  } finally {
    dispatch(hideSpinner());
  }
};

export const getChangeLog = (siteId) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    const res = await getChangeLogService(siteId);
    return res;
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  } finally {
    dispatch(hideSpinner());
  }
};

export const getRerunBulkUpdateData = (siteId) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    const res = await getRerunBulkUpdateService(siteId);
    dispatch(setRerunBulkUpdateData(res));
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  } finally {
    dispatch(hideSpinner());
  }
};

export const createOrUpdateCutMeasurements = (data) => async (dispatch) => {
  await axios.post(`${API.siteRepo.root}${API.siteRepo.createUpdateCutsheetRollCutData}`, data);
};

export const deleteMeasurement = (data, siteId) => async (dispatch) => {
  try {
    dispatch(showSpinner());
    await deleteMeasurementService(data);
    const res = await getSite(siteId);
    res.projectDetailsList
      ? res.projectDetailsList?.map((project) => {
          project.isSelected = true;
          project.layerInfoList?.map((layer) => {
            layer.isSelected = true;
            layer.pictureData = layer.pictureData ? "data:image/jpeg;base64," + layer.pictureData : null;
          });
        })
      : (res.projectDetailsList = []);
    dispatch(setSiteData(res));
  } catch (error) {
    toast.error(`error occurred: ${err}`);
  } finally {
    dispatch(hideSpinner());
  }
};

export const editProject = (projectId, data) => async (dispatch) => {
  try {
    const res = await axios.patch(`/fc-site-repo/project/${projectId}`, data);
    dispatch(editProjectData(res.data));
  } catch (err) {
    toast.error(`error occurred: ${err}`);
  }
};

export const loadCutSheetData = (projectId) => async (dispatch) => {
  const cutSheetData = await getCutSheetsService(projectId);
  dispatch(loadCutSheetsData({ projectId, cutSheetData }));
};

export const deleteRollCut = (data) => async (dispatch) => {
  axios.post("/fc-site-repo/delete/rollcut", data);
  dispatch(deleteRollcutAction({ projectId: data.projectId, rollCutId: data.id }));
};
